export const months = [
    { id: 1, value: 'Janeiro' },
    { id: 2, value: 'Fevereiro' },
    { id: 3, value: 'Março' },
    { id: 4, value: 'Abril' },
    { id: 5, value: 'Maio' },
    { id: 6, value: 'Junho' },
    { id: 7, value: 'Julho' },
    { id: 8, value: 'Agosto' },
    { id: 9, value: 'Setembro' },
    { id: 10, value: 'Outubro' },
    { id: 11, value: 'Novembro' },
    { id: 12, value: 'Dezembro' },
  ];

  export const currentYear = new Date().getFullYear();
  export const maxYears = 2;
  export const initialYear = currentYear - maxYears;
  const rawYears = Array.from({ length: (currentYear - initialYear) / 1 + 1 }, (_, i) => initialYear + (i * 1));

  export const years = rawYears.map(year => ({id: year, value: year }));

